<ng-container [ngSwitch]="control.controlType">
    <div *ngSwitchCase="19" class="cp-generic cp-label" [ngClass]="cssClasses" [hidden]="isHidden">
        <ng-container *ngIf="labelUrl as url; else simpleLabel">
            <a [href]="url" rel="noreferrer" target="_blank">{{ control.name || "" | translate }}</a>
        </ng-container>
        <ng-template #simpleLabel>
            <span>{{ control.name || "" | translate }}</span>
        </ng-template>
    </div>

    <div *ngSwitchCase="50" class="cp-generic cp-image" [hidden]="isHidden">
        <se-floating-label *ngIf="control.isWithLabel">{{ control.name }}</se-floating-label>
        <img [src]="imagePath" [alt]="control.name" [height]="control.getHeight()" />
    </div>

    <div
        *ngSwitchCase="[60, 61, 63, 64] | switchMultiCase: control?.controlType"
        class="cp-generic cp-button"
        [ngClass]="cssClasses"
        [hidden]="isHidden"
        [matTooltip]="iconTooltip"
        matTooltipClass="mat-tooltip-cp"
    >
        <button
            *ngIf="!onlyIcon"
            class="density-comfy"
            mat-stroked-button
            (click)="onButtonClick()"
            [disabled]="isDisabled"
        >
            <mat-icon *ngIf="icon; let icon">{{ icon }}</mat-icon>
            {{ control.name | translate }}
        </button>

        <button *ngIf="onlyIcon" mat-icon-button (click)="onButtonClick()" [disabled]="isDisabled">
            <mat-icon *ngIf="onlyIcon && icon; let i">{{ i }}</mat-icon>
        </button>

        <se-modaldialog
            *ngIf="control?.controlType === 60"
            [alwaysPresent]="true"
            [closeOnHeader]="false"
            [header]="control.name | translate"
            [(visible)]="isUserControlModalVisible"
            [buttonOk]="false"
            [buttonClose]="true"
            [zIndex]="10000"
            [windowSize]="userControlModalSize"
        >
            <ng-template #userControlContainer content></ng-template>
        </se-modaldialog>
    </div>

    <div *ngSwitchCase="70" class="cp-generic cp-spacer" [ngStyle]="spacerCSSStyle" [hidden]="isHidden"></div>

    <!-- Sconosciuto -->
    <h1 *ngSwitchDefault [hidden]="isHidden">Controllo sconosciuto: {{ control.name || control.id || undefined }}</h1>
</ng-container>
